import levels from './permissionLevels';
import funcPermissions from './funcPermissions';

export default {
  apiEndpoint: 'https://jmholm.co/api',
  permissionLevels: levels,
  funcPermissions,
  default_tz: 'America/Chicago'
};




// WEBPACK FOOTER //
// ./src/config/index.js